import { ReactNode } from 'react';
import useAuth from '../hooks/useAuth';
import { ProfilePreviewProvider } from './ProfilePreviewContext';

type ProfilePreviewBridgeProps = {
  children: ReactNode;
};

export default function ProfilePreviewBridge({ children }: ProfilePreviewBridgeProps) {
  const { user } = useAuth();

  return (
    <ProfilePreviewProvider loginPermissions={user?.permissions}>
      {children}
    </ProfilePreviewProvider>
  );
}
